var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.900202 15.9243C0.900202 15.3557 1.37525 14.9 1.95455 14.9C2.53385 14.9 3.0089 15.3557 3.0089 15.9243C3.0089 20.3882 6.75848 24.0251 11.3742 24.0251C15.9898 24.0251 19.7394 20.3882 19.7394 15.9243C19.7394 15.3557 20.2144 14.9 20.7937 14.9C21.373 14.9 21.848 15.3557 21.848 15.9243C21.848 21.179 17.708 25.5084 12.4286 26.0222V30.5158C12.4286 31.0704 11.979 31.5199 11.4245 31.5199C10.8176 31.5199 10.3199 31.028 10.3199 30.4199V26.0222C5.04021 25.5086 0.900202 21.179 0.900202 15.9243Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0568 22.1C7.70132 22.1 4.95664 19.5929 4.95664 16.4934V6.50642C4.95664 3.40714 7.70132 0.9 11.0568 0.9C14.412 0.9 17.1566 3.40714 17.1566 6.50642V16.4934C17.1566 19.5929 14.412 22.1 11.0568 22.1ZM15.0827 6.50642C15.0827 4.48166 13.2848 2.82004 11.0568 2.82004C8.82872 2.82004 7.03082 4.48166 7.03082 6.50642V16.4934C7.03082 18.5181 8.82873 20.18 11.0568 20.18C13.2848 20.18 15.0827 18.5181 15.0827 16.4934V6.50642Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/unmute.779c3a05e0d8dd86d158e2cdd0683200.svg";
export { ForwardRef as ReactComponent };